import { render } from "./svg-message.vue?vue&type=template&id=bc54b644"
import script from "./svg-message.vue?vue&type=script&lang=ts"
export * from "./svg-message.vue?vue&type=script&lang=ts"
script.render = render

export default script